<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addGroup()">添加</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="delGroup()">删除</el-button>
    </div>
    <el-tabs v-model="tabIdx" @tab-click="chooseTab">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="未开始" name="1"></el-tab-pane>
      <el-tab-pane label="进行中" name="2"></el-tab-pane>
      <el-tab-pane label="已结束" name="3"></el-tab-pane>
    </el-tabs>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          align="center"
          width="55">
      </el-table-column>
      <el-table-column
          prop="goods_id"
          label="商品"
          min-width="250">
        <template slot-scope="scope">
          <div class="goods-box line">
            <div class="item">
              <img :src="scope.row.img" class="img small" />
              <span class="">{{scope.row.title}}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="start_time"
          label="活动时间"
          align="center"
          width="220">
        <template slot-scope="scope">
          <div>{{scope.row.start_time}}</div>
          <div style="line-height: 2px;">~</div>
          <div>{{scope.row.end_time}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="buy_type"
          label="购买方式"
          align="center"
          width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.buy_type==1">砍到任意金额可购买</div>
          <div v-if="scope.row.buy_type==2">砍到低价才可购买</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="times"
          label="砍价有效期"
          align="center"
          width="150">
        <template slot-scope="scope">
          <div>{{scope.row.times}} 分钟</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="order_limit"
          label="单人可发起的次数"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="limit_single"
          label="单次限购数量"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="limit_total"
          label="总限购次数"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="active_status"
          label="活动状态"
          align="center"
          width="150">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.active_status==1" type="success" size="small">进行中</el-tag>
          <el-tag v-if="scope.row.active_status==2" type="danger" size="small">已结束</el-tag>
          <el-tag v-if="scope.row.active_status==0" type="warning" size="small">未开始</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-switch
              :value="scope.row.status==1?'1':'0'"
              @change="shenheGroup(scope.row)"
              active-value="1"
              inactive-value="2"
              active-text="关闭"
              inactive-text="开启">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="150">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editGroup(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        keywords: '',
        active_status: '',
        current_page: 1,
        total: 0,
        limit: 10
      },
      tabIdx: 0,
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    chooseTab(e) {
      this.search.active_status = e.index
      this.handleSearch()
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        active_status: that.search.active_status
      }
      this.$api.marking.bargainIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    addGroup() {
      this.$router.push({name: 'marking_bargain_add'})
    },
    editGroup(item) {
      this.$router.push({name: 'marking_bargain_add', query: {id: item.id}})
    },
    delGroup() {
      var that = this
      var sel = this.$refs.rfTable.selection
      if (sel.length < 1) {
        that.tips('请选择删除项')
        return false
      }
      var ids = []
      sel.forEach(function (item) {
        ids.push(item.id)
      })
      this.$confirm('确认要删除这些数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.marking.bargainDel({ids: ids}, function (res) {
          if (res.errcode == 0) {
            that.success('删除成功')
            that.getList()
          } else {
            that.fail(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    shenheGroup(item) {
      this.$api.marking.bargainShenhe({id: item.id, status: item.status == 1 ? 0 : 1}, res => {
        if (res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
